"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamesOfWarEffectHandler = exports.FlamesOfWarEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Burning_1 = require("./Burning");
class FlamesOfWarEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.FlamesOfWar;
        this.__typeName = "FlamesOfWar";
        this.name = "Flames of War";
        this.harmful = true;
    }
}
exports.FlamesOfWarEffectArgs = FlamesOfWarEffectArgs;
let FlamesOfWarEffectHandler = class FlamesOfWarEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandlerScript(state.targetId, EventType_1.EventType.Attacked, Schedule_1.Schedule.Unlimited, "ApplyEffect_OnAttacked", {
            applyTo: "attacker",
            onHitOnly: true,
            effects: [
                {
                    percentChance: 50,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new Burning_1.BurningEffectArgs("Focus", 10),
                }
            ]
        });
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
FlamesOfWarEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.FlamesOfWar)
], FlamesOfWarEffectHandler);
exports.FlamesOfWarEffectHandler = FlamesOfWarEffectHandler;
